import React, { lazy, Suspense } from 'react';
import { useFullscreen } from 'react-use';
import { ToastProvider } from 'react-toast-notifications';
import { Toast, ToastContainer } from '../components/bootstrap/Toasts';
import useToken from '../pages/presentation/auth/userToken';
import Login from '../pages/presentation/auth/Login';
import { getOS } from '../helpers/helpers';

// On charge l'app "lourde" uniquement quand l'utilisateur est connecté
const AuthenticatedApp = lazy(() => import('./AuthenticatedApp'));

export const TokenContext = React.createContext();

const App = () => {
  const { token, setToken } = useToken();

  // Comportement existant conservé
  useFullscreen(document.body, false, { onClose: () => {} });
  getOS();

  // ➜ Visiteur non connecté : on ne charge QUE l'écran Login
  if (!token) {
    return (
		<ToastProvider components={{ ToastContainer, Toast }}>
			<Login setToken={setToken} />
		</ToastProvider>
	);
  }

  // ➜ Connecté : on charge à la demande toute l'application
  return (
    <Suspense fallback={null}>
      <AuthenticatedApp setToken={setToken} token={token} />
    </Suspense>
  );
};

export default App;
